// src/pages/KompresorDetay.jsx
import React, {useState,useEffect, useRef, useMemo, useCallback} from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import toast from 'react-hot-toast';
import './KompresorDetay.css';

const normalizeKod = (kod) => {
  if (!kod) return '';

  return String(kod)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
};

const benzersizId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const diziMi = (deger) => Array.isArray(deger) ? deger : [];

const sayiyaCevir = (deger, varsayilan = null) => {
  if (deger === '' || deger === null || deger === undefined) {
    return varsayilan;
  }

  const sayi = Number(deger);

  return Number.isFinite(sayi) ? sayi : varsayilan;
};

const apiIsteği = async (url, options = {}) => {
  const response = await fetch(url, options);

  if (!response.ok) {
    let hataMesaji = `İstek başarısız oldu: ${response.status}`;

    try {
      const data = await response.json();

      if (data?.hata) hataMesaji = data.hata;
      if (data?.message) hataMesaji = data.message;
      if (data?.error) hataMesaji = data.error;
    } catch {
      // Backend JSON döndürmeyebilir.
    }

    throw new Error(hataMesaji);
  }

  return response;
};

const sabitAlanlar = [
  { name: 'firma', placeholder: 'Firma Adı' },
  { name: 'model', placeholder: 'Model' },
  { name: 'seriNo', placeholder: 'Seri No' },
  { name: 'yetkili', placeholder: 'Yetkili' },
  { name: 'yetkiliTel', placeholder: 'Yetkili Tel' },
  { name: 'mail', placeholder: 'Mail' },
  { name: 'adres', placeholder: 'Adres' },
  { name: 'bakimTarihi', placeholder: 'Bakım Tarihi', type: 'date' },
  { name: 'toplamSaat', placeholder: 'Toplam Çalışma Saati', type: 'number', min: 0 },
  { name: 'yukteSaat', placeholder: 'Yükte Çalışma Saati', type: 'number', min: 0 },
  { name: 'bostaSaat', placeholder: 'Boşta Çalışma Saati', type: 'number', min: 0 },
  { name: 'gunlukCalismaSaati', placeholder: 'Günlük Çalışma Saati', type: 'number', min: 0 },
  { name: 'sonBakimTarihi', placeholder: 'Son Bakım Tarihi', type: 'date' },
  { name: 'modulKart', placeholder: 'Modül Kart Tipi / Şifre' },
  { name: 'elementSicaklik', placeholder: 'Element Sıcaklık', type: 'number' },
  { name: 'yagTipi', placeholder: 'Yağ Tipi ve Miktarı' },
  { name: 'imalYili', placeholder: 'Kompresör İmal Yılı', type: 'number' },
  { name: 'bakimDongusuA', placeholder: 'A Bakımı Döngüsü (saat)', type: 'number', min: 0 },
  { name: 'revizyonSaat', placeholder: 'Revizyon Saati', type: 'number', min: 0 }
];

const sayisalAlanlar = [
  'toplamSaat',
  'yukteSaat',
  'bostaSaat',
  'gunlukCalismaSaati',
  'elementSicaklik',
  'imalYili',
  'bakimDongusuA',
  'revizyonSaat'
];

const varsayilanParcaTurleri = [
  'YAĞ FİLTRESİ',
  'HAVA FİLTRESİ',
  'SEPERATÖR',
  'MPV',
  'OIL STOP VALF',
  'ÇEKVALF',
  'TERMOSTAT',
  'KEÇE',
  'KEÇE BURCU',
  'ERKEK ROTOR ÖN',
  'ERKEK ROTOR ARKA',
  'DİŞİ ROTOR ÖN',
  'DİŞİ ROTOR ARKA',
  'ELEKTRİK MOTOR R.',
  'FAN MOTOR R.',
  'SU TAHLİYE (DRAIN VALF)',
  'KURUTUCU VE HAT FİLTRE',
  'CAPLİN-KAYIŞ',
  'EMİŞ VALFİ',
  'REGULATING VALF'
];

const parcaAnahtariEsleme = {
  'RULMAN-1': 'ERKEK ROTOR ÖN',
  'RULMAN-2': 'ERKEK ROTOR ARKA',
  'RULMAN-3': 'DİŞİ ROTOR ÖN',
  'RULMAN-4': 'DİŞİ ROTOR ARKA'
};

const parcaAnahtarlariniGuncelle = (parcaListesi) => {
  const yeniListe = {};

  Object.entries(parcaListesi || {}).forEach(([eskiAd, deger]) => {
    const yeniAd = parcaAnahtariEsleme[eskiAd] || eskiAd;

    if (yeniListe[yeniAd]) {
      yeniListe[yeniAd] = [
        ...(Array.isArray(yeniListe[yeniAd]) ? yeniListe[yeniAd] : []),
        ...(Array.isArray(deger) ? deger : [])
      ];
    } else {
      yeniListe[yeniAd] = Array.isArray(deger) ? deger : [];
    }
  });

  return yeniListe;
};

const varsayilanAksamaTipleri = [
  'PANEL FİLTRE',
  'SEPERATÖR TANKI ORİNG',
  'EMİŞ VALFİ ORİNG',
  'ELEMENT BLOK ORİNG',
  'MINIMUM BASINÇ VALFİ ORİNG',

];

const oringMalzemeler = [
  'NBR',
  'FKM (Viton)',
  'EPDM',
  'Silikon',
  'PTFE',
  'Diğer'
];

const bosTedarikci = () => ({
  id: benzersizId(),
  adi: '',
  kod: '',
  fiyat: '',
  adet: ''
});

const bosORing = () => ({
  pozisyon: '',
  icCap: '',
  disCap: '',
  kalinlik: '',
  malzeme: 'NBR',
  kod: '',
  tedarikci: '',
  adet: '1',
  notlar: ''
});

const bosFiltre = () => ({
  tip: 'Hava',
  boyut: '',
  kod: '',
  tedarikci: '',
  degisimAraligi: ''
});

const ParcaTedarikciListesi = ({
  parcaKey,
  parca,
  handleTedarikciDegisiklik,
  handleTedarikciEkle,
  handleTedarikciSil,
  onMuadilYukle,
  muadilYukleniyor
}) => {
  return (
    <div className="parca-tedarikci-bolumu" style={{ marginBottom: 24 }}>
      <div className="parca-baslik-satir">
        <h3>{parcaKey}</h3>

        <button
          type="button"
          className="muadil-yukle-btn"
          onClick={() => {
            const sonGirilen = diziMi(parca).at(-1)?.kod;

            if (sonGirilen?.trim()) {
              onMuadilYukle?.(parcaKey, sonGirilen);
            } else {
              toast.error('⚠️ Önce bir parça kodu girin, sonra muadilleri yükleyin.');
            }
          }}
          disabled={muadilYukleniyor}
        >
          {muadilYukleniyor ? '⏳ Yükleniyor...' : '🔄 Muadilleri Yükle'}
        </button>
      </div>

      {diziMi(parca).map((tedarikci, index) => (
        <div
          key={tedarikci.id || `${parcaKey}-${index}`}
          className="tedarikci-satir"
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 0.8fr auto',
            gap: 8,
            marginBottom: 10
          }}
        >
          <Input
            placeholder="Tedarikçi Adı"
            value={tedarikci.adi ?? ''}
            onChange={(e) =>
              handleTedarikciDegisiklik(parcaKey, tedarikci.id, 'adi', e.target.value)
            }
          />

          <Input
            placeholder="Parça Kodu"
            value={tedarikci.kod ?? ''}
            onChange={(e) =>
              handleTedarikciDegisiklik(parcaKey, tedarikci.id, 'kod', e.target.value)
            }
          />

          <Input
            type="number"
            step="0.01"
            min="0"
            placeholder="Fiyat"
            value={tedarikci.fiyat ?? ''}
            onChange={(e) =>
              handleTedarikciDegisiklik(parcaKey, tedarikci.id, 'fiyat', e.target.value)
            }
          />

          <Input
            type="number"
            min="0"
            step="1"
            placeholder="Adet"
            value={tedarikci.adet ?? ''}
            onChange={(e) =>
              handleTedarikciDegisiklik(parcaKey, tedarikci.id, 'adet', e.target.value)
            }
          />

          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => handleTedarikciSil(parcaKey, tedarikci.id)}
          >
            ✕
          </Button>
        </div>
      ))}

      <Button
        type="button"
        onClick={() => handleTedarikciEkle(parcaKey)}
        variant="outline"
        size="sm"
        style={{ marginTop: 8 }}
      >
        ➕ Tedarikçi Ekle
      </Button>
    </div>
  );
};

const AksamaPaneli = ({ aksamlar, onChange }) => {
  const [seciliAksamaId, setSeciliAksamaId] = useState(null);
  const [yeniAksamaTip, setYeniAksamaTip] = useState('');

  const seciliAksama = useMemo(
    () => diziMi(aksamlar).find((aksama) => aksama.id === seciliAksamaId) || null,
    [aksamlar, seciliAksamaId]
  );

  const handleAksamaEkle = () => {
    const temizTip = yeniAksamaTip.trim();

    if (!temizTip) {
      toast.error('⚠️ Aksama tipi giriniz.');
      return;
    }

    const yeniAksama = {
      id: benzersizId(),
      aksamaTipi: temizTip,
      ad: temizTip,
      fotoUrl: '',
      notlar: '',
      oringler: [],
      filtreler: []
    };

    onChange([...diziMi(aksamlar), yeniAksama]);
    setYeniAksamaTip('');
    setSeciliAksamaId(yeniAksama.id);

    toast.success('✅ Aksama forma eklendi. Kalıcı kayıt için ana Kaydet düğmesine basın.');
  };

  const handleAksamaSil = (id) => {
    if (!window.confirm('Bu aksama ve tüm O-ring bilgileri silinecek. Emin misiniz?')) {
      return;
    }

    onChange(diziMi(aksamlar).filter((aksama) => aksama.id !== id));

    if (seciliAksamaId === id) {
      setSeciliAksamaId(null);
    }

    toast.success('✅ Aksama formdan kaldırıldı. Kalıcı kayıt için ana Kaydet düğmesine basın.');
  };

  const handleAksamaGuncelle = (guncellenmis) => {
    onChange(
      diziMi(aksamlar).map((aksama) =>
        aksama.id === guncellenmis.id ? guncellenmis : aksama
      )
    );
  };

  return (
    <div className="aksama-paneli" style={{ marginTop: 16 }}>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        <select
          value={yeniAksamaTip}
          onChange={(e) => setYeniAksamaTip(e.target.value)}
          style={{
            flex: 1,
            minWidth: 200,
            padding: '8px 12px',
            borderRadius: 6,
            border: '1px solid #d1d5db'
          }}
        >
          <option value="">⭕ Aksama Tipi Seçin</option>

          {varsayilanAksamaTipleri.map((tip) => (
            <option key={tip} value={tip}>
              {tip}
            </option>
          ))}
        </select>

        <Button type="button" onClick={handleAksamaEkle} size="sm">
          ➕ Aksama Ekle
        </Button>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(220px, 250px) 1fr',
          gap: 16
        }}
      >
        <div
          className="aksama-listesi"
          style={{
            border: '1px solid #e2e8f0',
            borderRadius: 8,
            padding: 8,
            maxHeight: 500,
            overflowY: 'auto'
          }}
        >
          {diziMi(aksamlar).length === 0 ? (
            <p
              style={{
                color: '#94a3b8',
                textAlign: 'center',
                padding: 20,
                fontSize: 13
              }}
            >
              Henüz aksama eklenmemiş
            </p>
          ) : (
            diziMi(aksamlar).map((aksama) => (
              <div
                key={aksama.id}
                onClick={() => setSeciliAksamaId(aksama.id)}
                style={{
                  padding: 10,
                  marginBottom: 4,
                  borderRadius: 6,
                  cursor: 'pointer',
                  backgroundColor:
                    seciliAksamaId === aksama.id ? '#dbeafe' : '#f8fafc',
                  border:
                    seciliAksamaId === aksama.id
                      ? '2px solid #3b82f6'
                      : '1px solid #e2e8f0'
                }}
              >
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: 13,
                    color: '#1e3a8a'
                  }}
                >
                  {aksama.aksamaTipi}
                </div>

                <div
                  style={{
                    fontSize: 11,
                    color: '#64748b',
                    marginTop: 2
                  }}
                >
                  ⭕ {diziMi(aksama.oringler).length} O-ring
                  {diziMi(aksama.filtreler).length > 0 &&
                    ` • 🔲 ${diziMi(aksama.filtreler).length} Filtre`}
                </div>
              </div>
            ))
          )}
        </div>

        <div
          className="aksama-detay"
          style={{
            border: '1px solid #e2e8f0',
            borderRadius: 8,
            padding: 16
          }}
        >
          {seciliAksama ? (
            <AksamaDetay
              key={seciliAksama.id}
              aksama={seciliAksama}
              onChange={handleAksamaGuncelle}
              onSil={() => handleAksamaSil(seciliAksama.id)}
            />
          ) : (
            <div
              style={{
                textAlign: 'center',
                padding: 40,
                color: '#94a3b8'
              }}
            >
              <p style={{ fontSize: 40, marginBottom: 8 }}>⭕</p>
              <p>Soldan bir aksama seçin veya yeni aksama ekleyin</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const AksamaDetay = ({ aksama, onChange, onSil }) => {
  const [yeniORing, setYeniORing] = useState(bosORing);
  const [yeniFiltre, setYeniFiltre] = useState(bosFiltre);

  const handleORingEkle = () => {
    const icCap = sayiyaCevir(yeniORing.icCap);
    const disCap = sayiyaCevir(yeniORing.disCap);
    const kalinlik = sayiyaCevir(yeniORing.kalinlik);
    const adet = sayiyaCevir(yeniORing.adet, 1);

    if (
      icCap === null ||
      disCap === null ||
      kalinlik === null ||
      icCap <= 0 ||
      disCap <= 0 ||
      kalinlik <= 0
    ) {
      toast.error('⚠️ O-ring ölçüleri pozitif sayı olmalıdır.');
      return;
    }

    if (disCap <= icCap) {
      toast.error('⚠️ Dış çap, iç çaptan büyük olmalıdır.');
      return;
    }

    if (!Number.isInteger(adet) || adet < 1) {
      toast.error('⚠️ Adet en az 1 olmalıdır.');
      return;
    }

    const oring = {
      id: benzersizId(),
      ...yeniORing,
      icCap,
      disCap,
      kalinlik,
      adet
    };

    onChange({
      ...aksama,
      oringler: [...diziMi(aksama.oringler), oring]
    });

    setYeniORing(bosORing());

    toast.success('✅ O-ring forma eklendi. Kalıcı kayıt için ana Kaydet düğmesine basın.');
  };

  const handleORingSil = (id) => {
    onChange({
      ...aksama,
      oringler: diziMi(aksama.oringler).filter((oring) => oring.id !== id)
    });

    toast.success('✅ O-ring formdan kaldırıldı. Kalıcı kayıt için ana Kaydet düğmesine basın.');
  };

  const handleORingGuncelle = (id, field, value) => {
    onChange({
      ...aksama,
      oringler: diziMi(aksama.oringler).map((oring) =>
        oring.id === id ? { ...oring, [field]: value } : oring
      )
    });
  };

  const handleFiltreEkle = () => {
    const temizKod = yeniFiltre.kod.trim();

    if (!temizKod) {
      toast.error('⚠️ Filtre kodu zorunludur.');
      return;
    }

    const filtre = {
      id: benzersizId(),
      ...yeniFiltre,
      kod: temizKod
    };

    onChange({
      ...aksama,
      filtreler: [...diziMi(aksama.filtreler), filtre]
    });

    setYeniFiltre(bosFiltre());

    toast.success('✅ Filtre forma eklendi. Kalıcı kayıt için ana Kaydet düğmesine basın.');
  };

  const handleFiltreSil = (id) => {
    onChange({
      ...aksama,
      filtreler: diziMi(aksama.filtreler).filter((filtre) => filtre.id !== id)
    });

    toast.success('✅ Filtre formdan kaldırıldı. Kalıcı kayıt için ana Kaydet düğmesine basın.');
  };

  const handleFiltreGuncelle = (id, field, value) => {
    onChange({
      ...aksama,
      filtreler: diziMi(aksama.filtreler).map((filtre) =>
        filtre.id === id ? { ...filtre, [field]: value } : filtre
      )
    });
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
          gap: 12,
          flexWrap: 'wrap'
        }}
      >
        <div style={{ flex: 1, minWidth: 220 }}>
          <h3 style={{ margin: 0, color: '#1e3a8a' }}>
            ⭕ {aksama.aksamaTipi}
          </h3>

          <Input
            placeholder="Aksama adı (opsiyonel)"
            value={aksama.ad ?? ''}
            onChange={(e) => onChange({ ...aksama, ad: e.target.value })}
            style={{ marginTop: 4, fontSize: 13 }}
          />
        </div>

        <Button variant="destructive" size="sm" onClick={onSil}>
          🗑️ Sil
        </Button>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label
          style={{
            fontSize: 13,
            fontWeight: 500,
            color: '#334155'
          }}
        >
          📝 Teknik Notlar
        </label>

        <textarea
          value={aksama.notlar ?? ''}
          onChange={(e) => onChange({ ...aksama, notlar: e.target.value })}
          placeholder="Bu aksama hakkında notlar..."
          rows={2}
          style={{
            width: '100%',
            padding: 8,
            borderRadius: 6,
            border: '1px solid #d1d5db',
            fontSize: 13,
            resize: 'vertical',
            marginTop: 4
          }}
        />
      </div>

      <div style={{ marginBottom: 20 }}>
        <h4
          style={{
            color: '#0c4a6e',
            borderBottom: '2px solid #e2e8f0',
            paddingBottom: 8,
            marginBottom: 12
          }}
        >
          ⭕ O-Ring'ler ({diziMi(aksama.oringler).length})
        </h4>

        {diziMi(aksama.oringler).length > 0 && (
          <div style={{ overflowX: 'auto', marginBottom: 12 }}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: 12
              }}
            >
              <thead>
                <tr style={{ backgroundColor: '#f1f5f9' }}>
                  <th style={{ padding: 6, border: '1px solid #e2e8f0', textAlign: 'left' }}>
                    Pozisyon
                  </th>
                  <th style={{ padding: 6, border: '1px solid #e2e8f0' }}>İç Çap</th>
                  <th style={{ padding: 6, border: '1px solid #e2e8f0' }}>Dış Çap</th>
                  <th style={{ padding: 6, border: '1px solid #e2e8f0' }}>Kalınlık</th>
                  <th style={{ padding: 6, border: '1px solid #e2e8f0' }}>Malzeme</th>
                  <th style={{ padding: 6, border: '1px solid #e2e8f0' }}>Kod</th>
                  <th style={{ padding: 6, border: '1px solid #e2e8f0' }}>Adet</th>
                  <th style={{ padding: 6, border: '1px solid #e2e8f0' }}>İşlem</th>
                </tr>
              </thead>

              <tbody>
                {diziMi(aksama.oringler).map((oring) => (
                  <tr key={oring.id}>
                    <td style={{ padding: 4, border: '1px solid #e2e8f0' }}>
                      <Input
                        value={oring.pozisyon ?? ''}
                        onChange={(e) =>
                          handleORingGuncelle(oring.id, 'pozisyon', e.target.value)
                        }
                        style={{ fontSize: 11, padding: 4 }}
                      />
                    </td>

                    <td
                      style={{
                        padding: 4,
                        border: '1px solid #e2e8f0',
                        textAlign: 'center'
                      }}
                    >
                      <Input
                        type="number"
                        step="0.1"
                        min="0"
                        value={oring.icCap ?? ''}
                        onChange={(e) =>
                          handleORingGuncelle(oring.id, 'icCap', e.target.value)
                        }
                        style={{
                          width: 60,
                          fontSize: 11,
                          padding: 4,
                          textAlign: 'center'
                        }}
                      />
                    </td>

                    <td
                      style={{
                        padding: 4,
                        border: '1px solid #e2e8f0',
                        textAlign: 'center'
                      }}
                    >
                      <Input
                        type="number"
                        step="0.1"
                        min="0"
                        value={oring.disCap ?? ''}
                        onChange={(e) =>
                          handleORingGuncelle(oring.id, 'disCap', e.target.value)
                        }
                        style={{
                          width: 60,
                          fontSize: 11,
                          padding: 4,
                          textAlign: 'center'
                        }}
                      />
                    </td>

                    <td
                      style={{
                        padding: 4,
                        border: '1px solid #e2e8f0',
                        textAlign: 'center'
                      }}
                    >
                      <Input
                        type="number"
                        step="0.01"
                        min="0"
                        value={oring.kalinlik ?? ''}
                        onChange={(e) =>
                          handleORingGuncelle(oring.id, 'kalinlik', e.target.value)
                        }
                        style={{
                          width: 60,
                          fontSize: 11,
                          padding: 4,
                          textAlign: 'center'
                        }}
                      />
                    </td>

                    <td style={{ padding: 4, border: '1px solid #e2e8f0' }}>
                      <select
                        value={oring.malzeme || 'NBR'}
                        onChange={(e) =>
                          handleORingGuncelle(oring.id, 'malzeme', e.target.value)
                        }
                        style={{
                          fontSize: 11,
                          padding: 4,
                          borderRadius: 4
                        }}
                      >
                        {oringMalzemeler.map((malzeme) => (
                          <option key={malzeme} value={malzeme}>
                            {malzeme}
                          </option>
                        ))}
                      </select>
                    </td>

                    <td style={{ padding: 4, border: '1px solid #e2e8f0' }}>
                      <Input
                        value={oring.kod ?? ''}
                        onChange={(e) =>
                          handleORingGuncelle(oring.id, 'kod', e.target.value)
                        }
                        style={{ fontSize: 11, padding: 4 }}
                      />
                    </td>

                    <td
                      style={{
                        padding: 4,
                        border: '1px solid #e2e8f0',
                        textAlign: 'center'
                      }}
                    >
                      <Input
                        type="number"
                        min="1"
                        step="1"
                        value={oring.adet ?? 1}
                        onChange={(e) =>
                          handleORingGuncelle(oring.id, 'adet', e.target.value)
                        }
                        style={{
                          width: 50,
                          fontSize: 11,
                          padding: 4,
                          textAlign: 'center'
                        }}
                      />
                    </td>

                    <td
                      style={{
                        padding: 4,
                        border: '1px solid #e2e8f0',
                        textAlign: 'center'
                      }}
                    >
                      <button
                        type="button"
                        onClick={() => handleORingSil(oring.id)}
                        style={{
                          background: '#ef4444',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          padding: '4px 8px',
                          cursor: 'pointer',
                          fontSize: 11
                        }}
                      >
                        ✕
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div
          style={{
            backgroundColor: '#f8fafc',
            border: '1px dashed #cbd5e1',
            borderRadius: 8,
            padding: 12
          }}
        >
          <p
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: '#475569',
              marginBottom: 8
            }}
          >
            ➕ Yeni O-Ring Ekle
          </p>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns:
                '1.5fr 1fr 1fr 1fr 1fr 1.5fr 0.5fr 0.5fr',
              gap: 6,
              alignItems: 'end'
            }}
          >
            <div>
              <label style={{ fontSize: 10, color: '#64748b' }}>Pozisyon</label>

              <Input
                placeholder="Üst kapak"
                value={yeniORing.pozisyon}
                onChange={(e) =>
                  setYeniORing({ ...yeniORing, pozisyon: e.target.value })
                }
                style={{ fontSize: 11, padding: 4 }}
              />
            </div>

            <div>
              <label style={{ fontSize: 10, color: '#64748b' }}>
                İç Çap (mm) *
              </label>

              <Input
                type="number"
                step="0.1"
                min="0"
                placeholder="25"
                value={yeniORing.icCap}
                onChange={(e) =>
                  setYeniORing({ ...yeniORing, icCap: e.target.value })
                }
                style={{ fontSize: 11, padding: 4 }}
              />
            </div>

            <div>
              <label style={{ fontSize: 10, color: '#64748b' }}>
                Dış Çap (mm) *
              </label>

              <Input
                type="number"
                step="0.1"
                min="0"
                placeholder="31"
                value={yeniORing.disCap}
                onChange={(e) =>
                  setYeniORing({ ...yeniORing, disCap: e.target.value })
                }
                style={{ fontSize: 11, padding: 4 }}
              />
            </div>

            <div>
              <label style={{ fontSize: 10, color: '#64748b' }}>
                Kalınlık (mm) *
              </label>

              <Input
                type="number"
                step="0.01"
                min="0"
                placeholder="3"
                value={yeniORing.kalinlik}
                onChange={(e) =>
                  setYeniORing({ ...yeniORing, kalinlik: e.target.value })
                }
                style={{ fontSize: 11, padding: 4 }}
              />
            </div>

            <div>
              <label style={{ fontSize: 10, color: '#64748b' }}>Malzeme</label>

              <select
                value={yeniORing.malzeme}
                onChange={(e) =>
                  setYeniORing({ ...yeniORing, malzeme: e.target.value })
                }
                style={{
                  width: '100%',
                  fontSize: 11,
                  padding: 5,
                  borderRadius: 4,
                  border: '1px solid #d1d5db'
                }}
              >
                {oringMalzemeler.map((malzeme) => (
                  <option key={malzeme} value={malzeme}>
                    {malzeme}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ fontSize: 10, color: '#64748b' }}>Kod</label>

              <Input
                placeholder="VK-1234"
                value={yeniORing.kod}
                onChange={(e) =>
                  setYeniORing({ ...yeniORing, kod: e.target.value })
                }
                style={{ fontSize: 11, padding: 4 }}
              />
            </div>

            <div>
              <label style={{ fontSize: 10, color: '#64748b' }}>Adet</label>

              <Input
                type="number"
                min="1"
                step="1"
                value={yeniORing.adet}
                onChange={(e) =>
                  setYeniORing({ ...yeniORing, adet: e.target.value })
                }
                style={{ fontSize: 11, padding: 4 }}
              />
            </div>

            <Button
              type="button"
              size="sm"
              onClick={handleORingEkle}
              style={{ fontSize: 11, padding: '4px 8px' }}
            >
              Ekle
            </Button>
          </div>
        </div>
      </div>

      <div>
        <h4
          style={{
            color: '#0c4a6e',
            borderBottom: '2px solid #e2e8f0',
            paddingBottom: 8,
            marginBottom: 12
          }}
        >
          🔲 Panel Filtreleri ({diziMi(aksama.filtreler).length})
        </h4>

        {diziMi(aksama.filtreler).map((filtre) => (
          <div
            key={filtre.id}
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1.5fr 1.5fr 1.5fr 1fr 0.5fr',
              gap: 6,
              marginBottom: 6,
              alignItems: 'center',
              padding: 6,
              backgroundColor: '#f8fafc',
              borderRadius: 6
            }}
          >
            <select
              value={filtre.tip || 'Hava'}
              onChange={(e) =>
                handleFiltreGuncelle(filtre.id, 'tip', e.target.value)
              }
              style={{
                fontSize: 12,
                padding: 4,
                borderRadius: 4
              }}
            >
              <option value="Hava">Hava</option>
              <option value="Yağ">Yağ</option>
              <option value="Yakıt">Yakıt</option>
              <option value="Hidrolik">Hidrolik</option>
              <option value="Diğer">Diğer</option>
            </select>

            <Input
              value={filtre.boyut ?? ''}
              onChange={(e) =>
                handleFiltreGuncelle(filtre.id, 'boyut', e.target.value)
              }
              placeholder="200x300x50 mm"
              style={{ fontSize: 12, padding: 4 }}
            />

            <Input
              value={filtre.kod ?? ''}
              onChange={(e) =>
                handleFiltreGuncelle(filtre.id, 'kod', e.target.value)
              }
              placeholder="Filtre kodu"
              style={{ fontSize: 12, padding: 4 }}
            />

            <Input
              value={filtre.degisimAraligi ?? ''}
              onChange={(e) =>
                handleFiltreGuncelle(
                  filtre.id,
                  'degisimAraligi',
                  e.target.value
                )
              }
              placeholder="Her 2000 saat"
              style={{ fontSize: 12, padding: 4 }}
            />

            <Input
              value={filtre.tedarikci ?? ''}
              onChange={(e) =>
                handleFiltreGuncelle(filtre.id, 'tedarikci', e.target.value)
              }
              placeholder="Tedarikçi"
              style={{ fontSize: 12, padding: 4 }}
            />

            <button
              type="button"
              onClick={() => handleFiltreSil(filtre.id)}
              style={{
                background: '#ef4444',
                color: 'white',
                border: 'none',
                borderRadius: 4,
                padding: '4px 8px',
                cursor: 'pointer',
                fontSize: 11
              }}
            >
              ✕
            </button>
          </div>
        ))}

        <div
          style={{
            backgroundColor: '#f8fafc',
            border: '1px dashed #cbd5e1',
            borderRadius: 8,
            padding: 12,
            marginTop: 8
          }}
        >
          <p
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: '#475569',
              marginBottom: 8
            }}
          >
            ➕ Yeni Filtre Ekle
          </p>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1.5fr 1.5fr 1.5fr 1fr 0.6fr',
              gap: 6,
              alignItems: 'end'
            }}
          >
            <div>
              <label style={{ fontSize: 10, color: '#64748b' }}>Tip</label>

              <select
                value={yeniFiltre.tip}
                onChange={(e) =>
                  setYeniFiltre({ ...yeniFiltre, tip: e.target.value })
                }
                style={{
                  width: '100%',
                  fontSize: 11,
                  padding: 5,
                  borderRadius: 4,
                  border: '1px solid #d1d5db'
                }}
              >
                <option value="Hava">Hava</option>
                <option value="Yağ">Yağ</option>
                <option value="Yakıt">Yakıt</option>
                <option value="Hidrolik">Hidrolik</option>
                <option value="Diğer">Diğer</option>
              </select>
            </div>

            <div>
              <label style={{ fontSize: 10, color: '#64748b' }}>Boyut</label>

              <Input
                placeholder="200x300x50"
                value={yeniFiltre.boyut}
                onChange={(e) =>
                  setYeniFiltre({ ...yeniFiltre, boyut: e.target.value })
                }
                style={{ fontSize: 11, padding: 4 }}
              />
            </div>

            <div>
              <label style={{ fontSize: 10, color: '#64748b' }}>Kod *</label>

              <Input
                placeholder="HF-100"
                value={yeniFiltre.kod}
                onChange={(e) =>
                  setYeniFiltre({ ...yeniFiltre, kod: e.target.value })
                }
                style={{ fontSize: 11, padding: 4 }}
              />
            </div>

            <div>
              <label style={{ fontSize: 10, color: '#64748b' }}>
                Değişim Aralığı
              </label>

              <Input
                placeholder="Her 2000 saat"
                value={yeniFiltre.degisimAraligi}
                onChange={(e) =>
                  setYeniFiltre({
                    ...yeniFiltre,
                    degisimAraligi: e.target.value
                  })
                }
                style={{ fontSize: 11, padding: 4 }}
              />
            </div>

            <div>
              <label style={{ fontSize: 10, color: '#64748b' }}>
                Tedarikçi
              </label>

              <Input
                placeholder="Mann"
                value={yeniFiltre.tedarikci}
                onChange={(e) =>
                  setYeniFiltre({
                    ...yeniFiltre,
                    tedarikci: e.target.value
                  })
                }
                style={{ fontSize: 11, padding: 4 }}
              />
            </div>

            <Button
              type="button"
              size="sm"
              onClick={handleFiltreEkle}
              style={{ fontSize: 11, padding: '4px 8px' }}
            >
              Ekle
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const KompresorDetay = () => {
  const [formData, setFormData] = useState({});
  const [parcaListesi, setParcaListesi] = useState({});
  const [yeniParcaAdi, setYeniParcaAdi] = useState('');
  const [tumKayitlar, setTumKayitlar] = useState([]);
  const [seciliKompresor, setSeciliKompresor] = useState(null);
  const [aramaTermi, setAramaTermi] = useState('');
  const [acilirMenu, setAcilirMenu] = useState(false);
  const [ozelNotlarModal, setOzelNotlarModal] = useState(false);
  const [muadiller, setMuadiller] = useState([]);
  const [muadilYukleniyor, setMuadilYukleniyor] = useState({});
  const [konumAliniyor, setKonumAliniyor] = useState(false);
  const [konumDogruluk, setKonumDogruluk] = useState(null);
  const [gpsKoordinat, setGpsKoordinat] = useState(null);
  const [loading, setLoading] = useState(true);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [aktifSekme, setAktifSekme] = useState('detaylar');
  const [aksamlar, setAksamlar] = useState([]);

  const ozelNotlarRef = useRef(null);
  const konumIstekKimligi = useRef(null);

  useEffect(() => {
    let iptalEdildi = false;

    const loadData = async () => {
      try {
        setLoading(true);

        const kayitlarRes = await apiIsteği('/api/kayitlar');
        const kayitlarData = await kayitlarRes.json();

        if (iptalEdildi) return;

        setTumKayitlar(diziMi(kayitlarData));

        try {
          const muadillerRes = await apiIsteği('/api/muadiller');
          const muadillerData = await muadillerRes.json();

          if (!iptalEdildi) {
            setMuadiller(diziMi(muadillerData));
          }
        } catch (muadilHatasi) {
          console.error('Muadil verileri alınamadı:', muadilHatasi);
          toast.error('⚠️ Cihaz kayıtları yüklendi, ancak muadil verileri alınamadı.');
        }
      } catch (err) {
        console.error('Veri çekme hatası:', err);

        if (!iptalEdildi) {
          toast.error(`❌ Cihaz kayıtları alınamadı: ${err.message}`);
        }
      } finally {
        if (!iptalEdildi) {
          setLoading(false);
        }
      }
    };

    loadData();

    return () => {
      iptalEdildi = true;
    };
  }, []);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  }, []);

  const handleTedarikciDegisiklik = useCallback(
    (parcaKey, tedarikciId, field, value) => {
      setParcaListesi((prev) => ({
        ...prev,
        [parcaKey]: diziMi(prev[parcaKey]).map((tedarikci) =>
          tedarikci.id === tedarikciId
            ? { ...tedarikci, [field]: value }
            : tedarikci
        )
      }));
    },
    []
  );

  const handleTedarikciEkle = useCallback((parcaKey) => {
    setParcaListesi((prev) => ({
      ...prev,
      [parcaKey]: [...diziMi(prev[parcaKey]), bosTedarikci()]
    }));
  }, []);

  const handleTedarikciSil = useCallback((parcaKey, tedarikciId) => {
    setParcaListesi((prev) => ({
      ...prev,
      [parcaKey]: diziMi(prev[parcaKey]).filter(
        (tedarikci) => tedarikci.id !== tedarikciId
      )
    }));
  }, []);

  const handleYeniParcaEkle = useCallback(() => {
    const temizAd = yeniParcaAdi.trim();

    if (!temizAd) return;

    if (parcaListesi[temizAd]) {
      toast.error('⚠️ Bu parça türü zaten mevcut.');
      return;
    }

    setParcaListesi((prev) => ({
      ...prev,
      [temizAd]: []
    }));

    setYeniParcaAdi('');
  }, [yeniParcaAdi, parcaListesi]);

  const muadilleriYukle = useCallback(
    (parcaKey, secilenKod) => {
      const aramaKodu = normalizeKod(secilenKod);

      if (!aramaKodu) {
        toast.error('⚠️ Lütfen geçerli bir parça kodu girin.');
        return;
      }

      if (diziMi(muadiller).length === 0) {
        toast.error('⏳ Muadil verileri henüz yüklenmedi. Lütfen bekleyin.');
        return;
      }

      const eslenmisParcaKey = parcaAnahtariEsleme[parcaKey] || parcaKey;
const normalizeParcaKey = normalizeKod(eslenmisParcaKey);

      const kodEslesiyor = (kod) => {
  const normalizeKodDegeri = normalizeKod(kod);

  if (!normalizeKodDegeri || !aramaKodu) return false;

  return (
    normalizeKodDegeri === aramaKodu ||
    normalizeKodDegeri.includes(aramaKodu) ||
    aramaKodu.includes(normalizeKodDegeri)
  );
};

      const kategoriGruplari = diziMi(muadiller).filter(
        (grup) => normalizeKod(grup.kategori) === normalizeParcaKey
      );

      let bulunanGrup = kategoriGruplari.find((grup) =>
  diziMi(grup.parcalar).some((parca) => kodEslesiyor(parca.kod))
);

      let farkliKategoriden = false;

      if (!bulunanGrup) {
        bulunanGrup = diziMi(muadiller).find((grup) =>
  diziMi(grup.parcalar).some((parca) => kodEslesiyor(parca.kod))
);

        farkliKategoriden = Boolean(bulunanGrup);
      }

      if (!bulunanGrup) {
        const kategoriKodlari = kategoriGruplari
          .flatMap((grup) => diziMi(grup.parcalar).map((parca) => parca.kod))
          .filter(Boolean)
          .slice(0, 5);

        toast.error(
          `ℹ️ "${secilenKod}" bulunamadı. Kategorideki örnek kodlar: ${
            kategoriKodlari.join(', ') || '—'
          }`
        );

        return;
      }

      setMuadilYukleniyor((prev) => ({
        ...prev,
        [parcaKey]: true
      }));

      const katalogMuadilleri = diziMi(bulunanGrup.parcalar).map((parca) => ({
        id: benzersizId(),
        adi: parca.tedarikci ?? '',
        kod: parca.kod ?? '',
        fiyat: parca.fiyat ?? '',
        adet: sayiyaCevir(parca.adet, 1)
      }));

      setParcaListesi((prev) => {
        const mevcutListe = diziMi(prev[parcaKey]);

  // Kullanıcının yalnızca arama için yazdığı satırı kaldır.
        const aramaSatiriHaric = mevcutListe.filter((parca) => {
          const normalizeSatirKodu = normalizeKod(parca.kod);

          if (!normalizeSatirKodu || !aramaKodu) return true;

          return (
            normalizeSatirKodu !== aramaKodu &&
            !normalizeSatirKodu.includes(aramaKodu) &&
            !aramaKodu.includes(normalizeSatirKodu)
          );
        });

        const mevcutKodlar = new Set(
          aramaSatiriHaric
            .map((parca) => normalizeKod(parca.kod))
            .filter(Boolean)
        );

        const eklenecekler = katalogMuadilleri.filter((parca) => {
          const normalizeKodDegeri = normalizeKod(parca.kod);

          return (
            normalizeKodDegeri !== '' &&
            !mevcutKodlar.has(normalizeKodDegeri)
          );
        });

        return {
          ...prev,
          [parcaKey]: [...aramaSatiriHaric, ...eklenecekler]
        };
      });

      const eklenenAdet = katalogMuadilleri.filter((parca) =>
        normalizeKod(parca.kod)
      ).length;

      toast.success(
        `✅ ${eklenenAdet} muadil "${parcaKey}" bölümüne eklendi${
          farkliKategoriden
            ? ` (eşleşme: ${bulunanGrup.kategori})`
            : ''
        }. Kalıcı kayıt için ana Kaydet düğmesine basın.`
      );

      setTimeout(() => {
        setMuadilYukleniyor((prev) => ({
          ...prev,
          [parcaKey]: false
        }));
      }, 300);
    },
    [muadiller]
  );

  const filtrelenmisKayitlar = useMemo(() => {
    const arama = aramaTermi.toLowerCase().trim();

    if (!arama) {
      return diziMi(tumKayitlar);
    }

    return diziMi(tumKayitlar).filter((kayit) =>
      `${kayit.firma ?? ''} - ${kayit.model ?? ''} - ${
        kayit.seriNo ?? ''
      }`
        .toLowerCase()
        .includes(arama)
    );
  }, [tumKayitlar, aramaTermi]);

  const handleSec = useCallback((kayit) => {
  setFormData({ ...kayit });

  setParcaListesi(
    parcaAnahtarlariniGuncelle(
      kayit.parcalar && typeof kayit.parcalar === 'object'
        ? kayit.parcalar
        : {}
    )
  );

  setAksamlar(Array.isArray(kayit.aksamlar) ? kayit.aksamlar : []);

  setSeciliKompresor({
    id: kayit.id ?? null,
    firma: kayit.firma ?? '',
    model: kayit.model ?? '',
    seriNo: kayit.seriNo ?? ''
  });

  setAramaTermi(
    `${kayit.firma ?? ''} - ${kayit.model ?? ''}${
      kayit.seriNo ? ` - ${kayit.seriNo}` : ''
    }`
  );

  setAcilirMenu(false);

  setGpsKoordinat(kayit.gpsKoordinat ?? null);
  setKonumDogruluk(kayit.konumDogruluk ?? null);
}, []);

  const handleOzelNotlarKaydet = () => {
    setFormData((prev) => ({
      ...prev,
      ozelNotlar: ozelNotlarRef.current?.value ?? ''
    }));

    setOzelNotlarModal(false);

    toast.success('✅ Notlar forma eklendi. Kalıcı kayıt için ana Kaydet düğmesine basın.');
  };

  const mevcutKonumuAl = useCallback(() => {
    if (!navigator.geolocation) {
      toast.error('❌ Tarayıcınız konum özelliğini desteklemiyor.');
      return;
    }

    const istekKimligi = benzersizId();
    konumIstekKimligi.current = istekKimligi;

    setKonumAliniyor(true);
    setKonumDogruluk(null);
    setGpsKoordinat(null);

    const gecerliIstek = () =>
      konumIstekKimligi.current === istekKimligi;

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        if (!gecerliIstek()) return;

        const { latitude, longitude, accuracy } = position.coords;

        setGpsKoordinat({ lat: latitude, lng: longitude });
        setKonumDogruluk(Math.round(accuracy));

        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1&accept-language=tr`
          );

          if (!response.ok) {
            throw new Error('Adres servisi cevap vermedi.');
          }

          const data = await response.json();

          if (!gecerliIstek()) return;

          const adres = data?.address;
          const adresParcalari = [
            adres?.road,
            adres?.house_number,
            adres?.neighbourhood,
            adres?.suburb,
            adres?.village,
            adres?.town,
            adres?.city,
            adres?.state
          ].filter(Boolean);

          const tamAdres = adresParcalari.join(', ');

          setFormData((prev) => ({
            ...prev,
            adres:
              tamAdres ||
              data?.display_name ||
              `Enlem: ${latitude}, Boylam: ${longitude}`
          }));

          if (accuracy > 500) {
            toast.error(
              `⚠️ Konum ~${Math.round(accuracy)}m doğrulukta. GPS ayarlarını kontrol edin.`
            );
          } else if (accuracy > 100) {
            toast(
              `ℹ️ Konum ~${Math.round(accuracy)}m doğrulukta. Sokak/bina no kontrol edin.`,
              { icon: 'ℹ️' }
            );
          }
        } catch (error) {
          console.error('Adres çözümleme hatası:', error);

          if (!gecerliIstek()) return;

          setFormData((prev) => ({
            ...prev,
            adres: `Enlem: ${latitude}, Boylam: ${longitude}`
          }));

          toast.error(
            '⚠️ Adres çözümlenemedi. Koordinatlar forma alındı; kalıcı kayıt için ana Kaydet düğmesine basın.'
          );
        } finally {
          if (gecerliIstek()) {
            setKonumAliniyor(false);
          }
        }
      },
      (error) => {
        if (!gecerliIstek()) return;

        setKonumAliniyor(false);

        let mesaj = 'Konum alınamadı.';

        if (error.code === 1) mesaj = 'Konum izni reddedildi.';
        else if (error.code === 2) mesaj = 'Konum bilgisi kullanılamıyor.';
        else if (error.code === 3) mesaj = 'Konum alma zaman aşımı.';

        toast.error(`❌ ${mesaj}`);
      },
      {
        enableHighAccuracy: true,
        timeout: 30000,
        maximumAge: 0
      }
    );
  }, []);

  const handleSave = useCallback(async () => {
    if (kaydediliyor) return;

    const zorunluAlanlar = ['firma', 'model', 'seriNo'];
    const eksikAlanlar = zorunluAlanlar.filter(
      (alan) => !String(formData[alan] ?? '').trim()
    );

    if (eksikAlanlar.length > 0) {
      toast.error(
        `❌ Zorunlu alanlar: ${eksikAlanlar
          .map(
            (alan) =>
              sabitAlanlar.find((sabitAlan) => sabitAlan.name === alan)
                ?.placeholder || alan
          )
          .join(', ')}`
      );

      return;
    }

    const seciliKayitId = seciliKompresor?.id ?? null;
    const seciliSeriNo = seciliKompresor?.seriNo ?? '';

    const mukerrer = diziMi(tumKayitlar).find((kayit) => {
      const ayniCihaz =
        kayit.firma === formData.firma &&
        kayit.model === formData.model &&
        kayit.seriNo === formData.seriNo;

      const ayniKayit =
        seciliKayitId !== null && kayit.id === seciliKayitId;

      const ayniSeriNo =
        seciliSeriNo !== '' && kayit.seriNo === seciliSeriNo;

      return ayniCihaz && !ayniKayit && !ayniSeriNo;
    });

    if (mukerrer) {
      const onay = window.confirm(
        `⚠️ "${formData.firma} - ${formData.seriNo}" zaten kayıtlı!\n\nÜzerine yazmak istiyor musunuz?`
      );

      if (!onay) return;
    }

    const temizFormData = { ...formData };

    sayisalAlanlar.forEach((alan) => {
      const deger = temizFormData[alan];

      temizFormData[alan] =
        deger === '' || deger === null || deger === undefined
          ? ''
          : sayiyaCevir(deger, deger);
    });

    const veri = {
      ...temizFormData,
      parcalar: parcaListesi,
      aksamlar,
      gpsKoordinat,
      konumDogruluk
    };

    setKaydediliyor(true);

    try {
      const response = await apiIsteği('/api/kaydet', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(veri)
      });

      const sonuc = await response.json();

      if (sonuc?.durum !== 'ok') {
        throw new Error(sonuc?.hata || 'Kayıt işlemi başarısız oldu.');
      }

      toast.success(
        `✅ Kompresör kaydedildi! Toplam: ${sonuc.toplam ?? '—'}`
      );

      try {
        const kayitlarRes = await apiIsteği('/api/kayitlar');
        const kayitlarData = await kayitlarRes.json();

        setTumKayitlar(diziMi(kayitlarData));
      } catch (yenilemeHatasi) {
        console.error('Kayıt listesi yenilenemedi:', yenilemeHatasi);
        toast.error('⚠️ Kayıt yapıldı, ancak liste yenilenemedi.');
      }
    } catch (err) {
      console.error('Kaydetme hatası:', err);
      toast.error(`❌ Kayıt hatası: ${err.message}`);
    } finally {
      setKaydediliyor(false);
    }
  }, [
    kaydediliyor,
    formData,
    seciliKompresor,
    tumKayitlar,
    parcaListesi,
    aksamlar,
    gpsKoordinat,
    konumDogruluk
  ]);

  if (loading) {
    return (
      <div
        className="kompresor-wrapper"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '60vh'
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}>⏳</div>
          <p style={{ color: '#64748b' }}>
            Kompresör verileri yükleniyor...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="kompresor-wrapper">
      <Card className="kompresor-card">
        <CardContent>
          <h2 className="kompresor-title">Kompresör Detay Kayıt</h2>

          <div className="select-kayit">
            <div style={{ position: 'relative', width: '100%' }}>
              <Input
                placeholder="📋 Mevcut Kaydı Yazarak Ara (Firma - Model - Seri No)"
                value={aramaTermi}
                onChange={(e) => {
                  setAramaTermi(e.target.value);
                  setAcilirMenu(true);
                }}
                onFocus={() => {
                  if (filtrelenmisKayitlar.length > 0) {
                    setAcilirMenu(true);
                  }
                }}
                onBlur={() => {
                  setTimeout(() => setAcilirMenu(false), 150);
                }}
              />

              {acilirMenu && filtrelenmisKayitlar.length > 0 && (
                <ul
                  className="autocomplete-list"
                  style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'white',
                    border: '1px solid #ddd',
                    borderRadius: 6,
                    maxHeight: 200,
                    overflowY: 'auto',
                    zIndex: 1000,
                    listStyle: 'none',
                    padding: 0,
                    margin: 0,
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                  }}
                >
                  {filtrelenmisKayitlar.map((kayit) => (
                    <li
                      key={kayit.id || `${kayit.firma}-${kayit.model}-${kayit.seriNo}`}
                      onClick={() => handleSec(kayit)}
                      style={{
                        padding: '10px 12px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #eee',
                        fontSize: 14
                      }}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {kayit.firma} - {kayit.model}
                      {kayit.seriNo ? ` - ${kayit.seriNo}` : ''}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {seciliKompresor && (
              <span
                style={{
                  marginTop: 8,
                  fontSize: 14,
                  color: '#2563eb',
                  display: 'block'
                }}
              >
                🎯 Düzenleniyor: {seciliKompresor.firma} /{' '}
                {seciliKompresor.model}
                {seciliKompresor.seriNo
                  ? ` / ${seciliKompresor.seriNo}`
                  : ''}
              </span>
            )}
          </div>

          <div
            style={{
              display: 'flex',
              gap: 4,
              marginTop: 16,
              marginBottom: 16,
              borderBottom: '2px solid #e2e8f0',
              overflowX: 'auto'
            }}
          >
            {[
              { id: 'detaylar', label: '📋 Detaylar' },
              { id: 'parcalar', label: '🔧 Parçalar & Tedarikçiler' },
              { id: 'aksamlar', label: '⭕ Aksamlar & O-Ring' }
            ].map((sekme) => (
              <button
                key={sekme.id}
                type="button"
                onClick={() => setAktifSekme(sekme.id)}
                aria-current={aktifSekme === sekme.id ? 'page' : undefined}
                style={{
                  padding: '10px 16px',
                  border: 'none',
                  borderBottom:
                    aktifSekme === sekme.id
                      ? '3px solid #3b82f6'
                      : '3px solid transparent',
                  backgroundColor: 'transparent',
                  color:
                    aktifSekme === sekme.id ? '#1e3a8a' : '#64748b',
                  fontWeight:
                    aktifSekme === sekme.id ? 600 : 400,
                  cursor: 'pointer',
                  fontSize: 14,
                  transition: 'all 0.2s',
                  whiteSpace: 'nowrap'
                }}
              >
                {sekme.label}
              </button>
            ))}
          </div>

          {aktifSekme === 'detaylar' && (
            <>
              <div className="input-grid">
                {sabitAlanlar.map(
                  ({ name, placeholder, type = 'text', min }) => {
                    if (name === 'adres') {
                      return (
                        <div
                          key={name}
                          className="input-wrapper-adres"
                          style={{ gridColumn: '1 / -1' }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              gap: 8,
                              width: '100%'
                            }}
                          >
                            <Input
                              name={name}
                              type={type}
                              placeholder={placeholder}
                              value={formData[name] ?? ''}
                              onChange={handleChange}
                              className="adres-input"
                              style={{ flex: 1 }}
                            />

                            <button
                              type="button"
                              onClick={mevcutKonumuAl}
                              disabled={konumAliniyor}
                              className="location-btn"
                              title="Mevcut Konumu Otomatik Al"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 44,
                                height: 44,
                                padding: 0,
                                border: '1px solid #d1d5db',
                                backgroundColor: '#ffffff',
                                borderRadius: 8,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                fontSize: 18,
                                flexShrink: 0
                              }}
                            >
                              {konumAliniyor ? '⏳' : '📍'}
                            </button>
                          </div>

                          {konumDogruluk !== null && gpsKoordinat && (
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 8,
                                marginTop: 8,
                                padding: 12,
                                backgroundColor:
                                  konumDogruluk <= 50
                                    ? '#f0fdf4'
                                    : konumDogruluk <= 200
                                    ? '#fefce8'
                                    : '#fef2f2',
                                border: `1px solid ${
                                  konumDogruluk <= 50
                                    ? '#bbf7d0'
                                    : konumDogruluk <= 200
                                    ? '#fde047'
                                    : '#fecaca'
                                }`,
                                borderRadius: 6,
                                fontSize: 13
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 8,
                                  flexWrap: 'wrap'
                                }}
                              >
                                <span
                                  style={{
                                    fontWeight: 600,
                                    color:
                                      konumDogruluk <= 50
                                        ? '#16a34a'
                                        : konumDogruluk <= 200
                                        ? '#ca8a04'
                                        : '#dc2626'
                                  }}
                                >
                                  📡 GPS: {konumDogruluk}m
                                </span>

                                <span
                                  style={{
                                    color: '#4b5563',
                                    fontFamily: 'monospace'
                                  }}
                                >
                                  🌐 {gpsKoordinat.lat.toFixed(6)},{' '}
                                  {gpsKoordinat.lng.toFixed(6)}
                                </span>
                              </div>

                              <a
                                href={`https://www.google.com/maps?q=${gpsKoordinat.lat},${gpsKoordinat.lng}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: '#2563eb',
                                  textDecoration: 'none',
                                  fontWeight: 600
                                }}
                              >
                                🗺️ Haritada Gör
                              </a>
                            </div>
                          )}
                        </div>
                      );
                    }

                    return (
                      <Input
                        key={name}
                        name={name}
                        type={type}
                        min={min}
                        placeholder={placeholder}
                        value={formData[name] ?? ''}
                        onChange={handleChange}
                      />
                    );
                  }
                )}
              </div>

              <div style={{ marginTop: 16, textAlign: 'center' }}>
                <Button
                  type="button"
                  onClick={() => setOzelNotlarModal(true)}
                  variant="outline"
                  style={{
                    width: '100%',
                    padding: 10,
                    justifyContent: 'center'
                  }}
                >
                  📝 Özel Notlar (
                  {formData.ozelNotlar ? 'Düzenle' : 'Ekle'})
                </Button>
              </div>
            </>
          )}

          {aktifSekme === 'parcalar' && (
            <>
              {[
                ...varsayilanParcaTurleri,
                ...Object.keys(parcaListesi).filter(
                  (parca) => !varsayilanParcaTurleri.includes(parca)
                )
              ].map((parca) => (
                <ParcaTedarikciListesi
                  key={parca}
                  parcaKey={parca}
                  parca={diziMi(parcaListesi[parca])}
                  handleTedarikciDegisiklik={handleTedarikciDegisiklik}
                  handleTedarikciEkle={handleTedarikciEkle}
                  handleTedarikciSil={handleTedarikciSil}
                  onMuadilYukle={muadilleriYukle}
                  muadilYukleniyor={muadilYukleniyor[parca]}
                />
              ))}

              <div
                className="new-part-section"
                style={{
                  display: 'flex',
                  gap: 8,
                  marginTop: 16
                }}
              >
                <Input
                  placeholder="Yeni Parça Türü Ekle"
                  value={yeniParcaAdi}
                  onChange={(e) => setYeniParcaAdi(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleYeniParcaEkle();
                    }
                  }}
                />

                <Button type="button" onClick={handleYeniParcaEkle}>
                  ➕ Ekle
                </Button>
              </div>
            </>
          )}

          {aktifSekme === 'aksamlar' && (
            <AksamaPaneli
              aksamlar={aksamlar}
              onChange={setAksamlar}
            />
          )}

          <button
            type="button"
            className="save-button"
            onClick={handleSave}
            disabled={kaydediliyor}
            style={{
              marginTop: 24,
              padding: '10px 20px',
              backgroundColor: kaydediliyor ? '#6ee7b7' : '#10b981',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              fontWeight: 'bold',
              cursor: kaydediliyor ? 'not-allowed' : 'pointer',
              width: '100%'
            }}
          >
            {kaydediliyor ? '⏳ Kaydediliyor...' : '💾 Kaydet'}
          </button>
        </CardContent>
      </Card>

      {ozelNotlarModal && (
        <div
          className="modal-overlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="ozel-notlar-baslik"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 2000
          }}
          onClick={() => setOzelNotlarModal(false)}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: 24,
              borderRadius: 12,
              width: '90%',
              maxWidth: 800,
              maxHeight: '80vh',
              overflow: 'hidden'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3
              id="ozel-notlar-baslik"
              style={{ marginBottom: 16, fontWeight: 'bold' }}
            >
              📝 Özel Notlar
            </h3>

            <textarea
              ref={ozelNotlarRef}
              defaultValue={formData.ozelNotlar ?? ''}
              style={{
                width: '100%',
                height: 300,
                padding: 12,
                border: '1px solid #ccc',
                borderRadius: 6,
                fontSize: 14,
                fontFamily: 'Arial, sans-serif',
                resize: 'vertical'
              }}
            />

            <div
              style={{
                marginTop: 16,
                display: 'flex',
                gap: 12,
                justifyContent: 'flex-end'
              }}
            >
              <Button
                variant="outline"
                onClick={() => setOzelNotlarModal(false)}
              >
                İptal
              </Button>

              <Button onClick={handleOzelNotlarKaydet}>Kaydet</Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KompresorDetay;